import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { nFormatter } from "../../../Helpers";
import CurrencySymbol from "../../../Components/common/CurrencySymbol";
import { ExdInfoTip } from "./ExdControls";
import {
  getKpiTheme,
  KpiCardShell,
  KpiCardValue,
  KpiHeader,
  KpiMeter,
  KpiSkeleton,
  KpiSubRow,
} from "./kpiMui";

const PredictiveServicesCard = ({
  loading,
  translate,
  businessPotential,
  loginUserCurrency,
  infoTitle,
  accent = "outstanding",
}) => {
  if (loading) return <KpiSkeleton />;

  const theme = getKpiTheme(accent);

  return (
    <KpiCardShell accent={accent}>
      <KpiHeader
        title={translate("Predictive Services")}
        info={<ExdInfoTip title={infoTitle} tone={theme.infoTone} />}
      />

      <Tooltip
        title={
          <Typography sx={{ fontSize: 14 }}>
            {businessPotential?.totalBusinessPotentialCount?.toLocaleString() ||
              0}
          </Typography>
        }
      >
        <Box>
          <KpiCardValue theme={theme}>
            {(
              Math.round(businessPotential?.totalBusinessPotentialCount) || 0
            ).toLocaleString()}
          </KpiCardValue>
        </Box>
      </Tooltip>

      <KpiMeter value={72} theme={theme} />

      <KpiSubRow sx={{ color: theme.muted }}>
        <Typography component="span" sx={{ fontSize: "inherit", color: "inherit" }}>
          vehicles due
        </Typography>
      </KpiSubRow>

      <KpiSubRow sx={{ color: theme.muted }}>
        <Typography component="span" sx={{ fontSize: "inherit", color: "inherit" }}>
          {translate("Business Potential")}
        </Typography>
        <Box component="b" sx={{ color: theme.color }}>
          {businessPotential?.totalBusinessPotential
            ? nFormatter(businessPotential.totalBusinessPotential, 2)
            : 0}{" "}
          <CurrencySymbol
            currency={loginUserCurrency}
            withParentheses={false}
          />
        </Box>
      </KpiSubRow>
    </KpiCardShell>
  );
};

export default PredictiveServicesCard;
